import React from "react";


function About() {
  return (
    <section className="about-us py-5">
      <div className="container">
        <div className="row align-items-center">
          {/* Left Side: About Us Text */}
          <div className="col-md-6">
            <div className="p-4 shadow-lg rounded bg-light">
              <h2 className="mb-4 text-primary fw-bold">About Us</h2>
              <p className="text-dark">
                <strong>Ptrans And Controls (PTC)</strong> is a Pune-based leader in
                industrial automation solutions, offering a wide range of
                instrumentation—from flow, level, and pressure sensors, to advanced
                LED displays, data loggers, and control panels.
              </p>
              <p className="text-dark">
                Serving industries like pharmaceuticals, power, chemicals, water
                treatment, and manufacturing, PTC delivers tailored, ISO-certified
                solutions with unmatched quality and support.
              </p>
              <a href="#contact" className="btn btn-primary mt-3 px-4 py-2">
                Learn More
              </a>
            </div>
          </div>

          {/* Right Side: About Us Image */}
          <div className="col-md-6">
            <div className="about-img shadow-lg rounded overflow-hidden">
              <img
                src="images/About.png"
                alt="About PTC"
                className="img-fluid w-100 h-100"
                style={{ objectFit: "cover", minHeight: "400px" }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
